import { accessibleBy } from "@casl/mongoose"

import type { AclAction, AclSubjectType, AppAbility } from "./types"


export const getAccessibleByQuery = (
  ability: AppAbility,
  action: AclAction,
  subject: Exclude<AclSubjectType, "all">,
): Record<string, unknown> => {
  return accessibleBy(ability, action).ofType(subject)
}
